export default {"src":"/_next/static/media/tray-logo.2435fcd9.svg","height":23,"width":85,"blurWidth":0,"blurHeight":0};